import { Directive, Input, HostListener } from '@angular/core';
import * as $ from 'jquery';
import { NormalReportService } from "../../../services/normalreport.service";
import { AlertService } from "../../../providers/alert.service";

//撤单指令
//TQQ 2017-05-08
@Directive({
    selector: '[revocation]',
    providers: [NormalReportService]
})
export class RevocationDirective {
    constructor(
        private alert: AlertService,
        private normalreport: NormalReportService
    ) { }
    @Input('revocation') Data: any;
    @HostListener('click') onMouseEnter() {
        if (!this.Data) {
            throw new Error('miss Data');
        } else {
            if (!this.Data.IssueId) {
                throw new Error('miss options: IssueId');
            } else {
                if (this.Data.ischase) {
                    this.allRevocation(this.Data);
                } else {
                    this.normalRevocation(this.Data);
                }
            }
        }
    }

    //常规撤单
    //TQQ 2017-05-08
    normalRevocation(data) {
        let type = data.ModeType,
            issueId =  data.IssueId;
        this.alert.confirmAlert('确定要撤销该订单？', '', null, yes => {
            this.alert.Loading('正在撤单...');
            this.normalreport.revocationCommand(issueId,type).catch(() => {
            }).then(s => {
                if (s['Result']) {
                    this.alert.okAlert(s['Error'], '', true, null, end => {
                        this.alert.CloseLoading();
                    });
                    if (data.callback != null && $.isFunction(data.callback)) {
                        data.callback(s);
                    }
                } else {
                    this.alert.errorAlert(s['Error'], '', true, null, end => {
                        this.alert.CloseLoading();
                    });
                }
            })
        });
    }

    //全部撤单
    //TQQ 2017-05-08
    allRevocation(data) {
        let bettingId = data.IssueId,
            ModeType = data.ModeType;
        this.alert.confirmAlert('确定要撤销该订单所有未开奖的期数？', '', null, yes => {
            this.alert.Loading('正在撤单...');
            this.normalreport.allrevocationCommand(ModeType,bettingId).catch(() => {
            }).then(s => {
                if (s['Result']) {
                    this.alert.okAlert(s['Error'], '', true, null, end => {
                        this.alert.CloseLoading();
                    });
                    if (data.callback != null && $.isFunction(data.callback)) {
                        data.callback(s);
                    }
                } else {
                    this.alert.errorAlert(s['Error'], '', true, null, end => {
                        this.alert.CloseLoading();
                    });
                }
            })
        });
    }
}




// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/shared/revocation/revocation.directive.ts